export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Tipo de venta',
	plural_model_name_spanish: 'Tipos de venta',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}